export function animate(frameFn, fps) {
  if (!frameFn) {
    return;
  }
  const interval = fps ? 1000 / fps : undefined;
  let last;
  let delta;
  let frame;
  const framesLastSecond = [];
  const animation = () => {
    requestId = requestAnimationFrame(animation);
    const now = performance.now();
    delta = last === undefined ? 0 : now - last;
    if (last === undefined || delta > interval) {
      last = now - (delta % interval);
      framesLastSecond.push(now);
      while (framesLastSecond.length && now - framesLastSecond[0] > 1000) {
        framesLastSecond.shift();
      }
      const fpsActual = framesLastSecond.length;
      frame = { now, last, delta, interval, fpsSetting: fps, fps: fpsActual };
      frameFn(frame);
    }
  };
  let requestId = requestAnimationFrame(animation);
  return () => cancelAnimationFrame(requestId);
}

export default animate;
